import React, { useCallback } from 'react';
import { createUseStyles, useTheme } from 'react-jss';

import { Theme } from '@app/theme';

import { Criterion, ParticipantField } from '@app/api';
import { DeletableItem } from 'components';
import {
  getCriterionFieldInput,
  isFieldHandleQuota,
} from './criterionFormFields';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    marginTop: theme.marginBase * 3,
  },
  criterionContainer: {
    borderRadius: theme.borderRadius.std,
  },
  criterionNoQuotaContainer: {
    borderRadius: theme.borderRadius.std,
    backgroundColor: theme.colors.grayBackground,
    padding: theme.marginBase * 2,
  },
}));

interface Props {
  criterion: Criterion;
  field?: ParticipantField;
  removeCriterion?: (criterion: Criterion) => any;
  onCriterionChanged: (criterion: Criterion) => any;
  criteria: Criterion[];
  allowedFields?: string[];
  numberOfParticipantRequired: number;
}

export const CriterionValueSelection = ({
  criterion,
  field,
  removeCriterion,
  onCriterionChanged,
  criteria,
  allowedFields,
  numberOfParticipantRequired,
}: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  const removable = !field?.criterion?.locked;
  const remove = useCallback(() => {
    if (removeCriterion) {
      removeCriterion(criterion);
    }
  }, [removeCriterion, criterion]);

  if (!field) {
    return null;
  }

  const Input = getCriterionFieldInput(field);
  if (!Input) {
    return null;
  }

  return (
    <DeletableItem
      onDeleteClick={removable ? remove : undefined}
      containerClassName={classes.container}
    >
      <div
        className={
          isFieldHandleQuota(field)
            ? classes.criterionContainer
            : classes.criterionNoQuotaContainer
        }
      >
        <Input
          field={field}
          small
          onChange={onCriterionChanged}
          noMargin
          label={field.label}
          value={criterion}
          criteria={criteria}
          allowedFields={allowedFields}
          numberOfParticipantRequired={numberOfParticipantRequired}
        />
      </div>
    </DeletableItem>
  );
};
